import { _, $ } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";

import DashboardWidgetTpl from "../../templates/dashboard/DashboardWidgetTpl.html";

/**
 * @view DashboardWidget
 * @author Felix Albroscheit
 *
 * Wrapper to handle dashboard-widgets more specificaly
 * in future times (drag & drop, change width, save latest tab...)
 */
export default InboomaBaseView.extend({
  template: DashboardWidgetTpl,

  ui: {
    li: "li.tabs-title:not(.is-active)",
  },

  events: {
    "click @ui.li": "_changeTab",
  },

  templateContext() {
    return {
      _,
      title: this.options.title,
      tabs: this.options.tabs,
      classes: this.options.classes,
      addButton: this.options.addButton,
    };
  },

  _changeTab(el) {
    el = $(el.currentTarget);
    el.parent().find(".is-active").removeClass("is-active");
    el.addClass("is-active");

    return false;
  },

  initialize() {
    this.render();
  },

  onRender() {
    const that = this;

    _.each(this.options.tabs, function (tab, c) {
      // @todo detach these events on destroy
      if (tab.onClick) {
        that.$el.find('[data-inb-val="' + c + '"]').on("click", tab.onClick);
      }
      if (tab.onAfterRender) {
        tab.onAfterRender(that.$el, c);
      }
    });
  },
});
